// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3mr8L","containerItemsCenter":"Skeleton_containerItemsCenter__2mfhS"};